import { CommandGroup, CommandItem } from "@components/ui/command";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import type { TeacherSearchResult } from "@shared-kernel/application/ports/admin/admin-repository";
import { TEACHER_STANDING } from "@user-management-context/read/domain/types/admin/teacher";
import { ORGANIZATION_NAME } from "@shared-kernel/domain/organization";

interface Props {
  teachers: TeacherSearchResult[];
  onSelect: (entityId: string) => void;
  getUrl: (entityId: string) => string;
  onClose: () => void;
}

export const TeacherResultGroup = ({ teachers, onSelect, getUrl, onClose }: Props) => {
  if (teachers.length === 0) return null;

  return (
    <CommandGroup heading="Professeurs">
      {teachers.map(teacher => (
        <CommandItem key={teacher.entityId} value={teacher.entityId} onSelect={() => onSelect(teacher.entityId)} className="p-0">
          <Link
            to={getUrl(teacher.entityId)}
            className="flex w-full items-center gap-3 px-2 py-1.5"
            onClick={e => {
              if (e.metaKey || e.ctrlKey) {
                e.stopPropagation();
              } else {
                onClose();
              }
            }}
          >
            {teacher.metadata.standing === TEACHER_STANDING.TRUSTED && <ShieldCheck className="size-4 text-green-700" />}
            <span className="flex-1 truncate">{teacher.label}</span>
            <span className="ml-auto text-xs text-muted-foreground">{ORGANIZATION_NAME[teacher.metadata.organization].short}</span>
          </Link>
        </CommandItem>
      ))}
    </CommandGroup>
  );
};
